import BodyView from "@/layout/BodyView.vue";
import Registration from "@/pages/clinic/registration/Index.vue";
import Patient from "@/pages/clinic/patient/Index.vue";
import Reservation from "@/pages/clinic/reservation/Index.vue";
import Closing from "@/pages/clinic/closing/Index.vue";
import Meddicine from "@/pages/clinic/meddicine/Index.vue";
import Therapy from "@/pages/clinic/therapy/Index.vue";
import Payment from "@/pages/clinic/payment/Index.vue";
import ReportMarketing from "@/pages/clinic/report/marketing/Index.vue";
import ReportSales from "@/pages/clinic/report/sales/Index.vue";
import ReportClosing from "@/pages/clinic/report/closing/Index.vue";
import ReportPayment from "@/pages/clinic/report/payment/Index.vue";
export const route = 
{
  path: "/clinic",
  component: BodyView,
  children: [
    {
      path: "patient",
      name: "patient",
      component: Patient,
      meta: {
        title: 'Patient | INDOFORCETECH',
      }
    },
    {
      path: "response",
      name: "response",
      component: Response,
      meta: {
        title: 'Response | INDOFORCETECH',
      }
    },
    {
      path: "registration",
      name: "registration",
      component: Registration,
      meta: {
        title: 'Registration | INDOFORCETECH',
      }
    },
    {
      path: "schedule",
      name: "schedule", 
      component: Reservation,
      meta: {
        title: 'Schedule | INDOFORCETECH',
      }
    },
    {
      path: "closing",
      name: "closing",
      component: Closing,
      meta: {
        title: 'Closing | INDOFORCETECH',
      }
    },
    {
      path: "meddicine",
      name: "meddicine",
      component: Meddicine,
      meta: {
        title: 'Medical Record | INDOFORCETECH',
      }
    },
    {
      path: "therapy",
      name: "therapy",
      component: Therapy,
      meta: {
        title: 'Therapy | INDOFORCETECH',
      }
    },
    {
      path: "payment",
      name: "payment",
      component: Payment,
      meta: {
        title: 'Payment | INDOFORCETECH',
      }
    },
    {
      path: "report-marketing",
      name: "report-marketing",
      component: ReportMarketing,
      meta: {
        title: 'Marketing Report | INDOFORCETECH',
      }
    },
    {
      path: "report-sales",
      name: "report-sales",
      component: ReportSales,
      meta: {
        title: 'Sales Report | INDOFORCETECH',
      }
    },
    {
      path: "report-CLosing",
      name: "report-CLosing",
      component: ReportClosing,
      meta: {
        title: 'Closing Report | INDOFORCETECH',
      }
    },
    {
      path: "report-payment",
      name: "report-payment", 
      component: ReportPayment,
      meta: {
        title: 'Payment Report | INDOFORCETECH',
      }
    }
  ]
}